import Handlebars from 'handlebars';

export const templateStr = (template: string, valueObj: { [key: string]: any }) => {
  let content = template || '';
  try {
    const applyValueToTemplate = Handlebars.compile(template || '', { noEscape: true });
    content = applyValueToTemplate(valueObj);
    content = content.replace(/\.en\.en/g, '.en ');
  } catch (err) {
    console.log(err);
  }
  return content;
};

export const templateStrFunc = (valueObj: { [key: string]: any }) => (template?: string | null) => templateStr(template || '', valueObj);

export const templateStrForStructuredData = (template: any, variables: { [key: string]: any }) => {
  const isArray = Array.isArray(template);
  const newTemplateStr = isArray ? [] : {} as any;

  Object.keys(template).forEach((key) => {
    const templateData = template[key];

    if (typeof templateData === 'string') {
      if (isArray) {
        newTemplateStr.push(templateStr(templateData, variables));
      } else {
        newTemplateStr[key] = templateStr(templateData, variables);
      }
    } else if (Array.isArray(templateData)) {
      newTemplateStr[key] = templateData.map((item) => templateStrForStructuredData(item, variables));
    } else if (typeof templateData === 'object' && templateData !== null) {
      newTemplateStr[key] = templateStrForStructuredData(templateData, variables);
    } else {
      newTemplateStr[key] = templateData;
    }
  });

  return newTemplateStr;
};
